import React, { useState, useCallback } from "react";
import { ReactSVG } from "react-svg";
import { useModals } from "@gw/component-library";
import { useEnvContext } from "@gw/env-context";
import { imgs } from "@gw/theming";
import { MapFiltersStyled, FilterButton, Counter } from "./MapFiltersStyled";
import ModalFilter from "./ModalFilter";
var MapFilters = function (_a) {
    var data = _a.data, filterCallback = _a.filterCallback, resetCallback = _a.resetCallback, visibleFarmers = _a.visibleFarmers, filteredFarmers = _a.filteredFarmers, resetMap = _a.resetMap, handleZoom = _a.handleZoom;
    var imgsFolder = useEnvContext().imgsFolder;
    var _b = useModals(), openModal = _b.openModal, closeModal = _b.closeModal;
    var _c = useState(0), filterSize = _c[0], setFilterSize = _c[1];
    var _d = useState({
        species: [],
        format: [],
        yield: [],
        stability: [],
        location: ["all"],
    }), filters = _d[0], setFilters = _d[1];
    var handleFilter = useCallback(function (filter, filteredData) {
        setFilters(filter);
        setFilterSize(Object.keys(filter)
            .map(function (key) { return filter[key].length; })
            .reduce(function (a, b) { return a + b; }, 0));
        filterCallback(filteredData);
    }, [filterCallback]);
    var handleModal = function () {
        var modalId = "filter-modal";
        openModal(modalId, "Filter", React.createElement(ModalFilter, { modalId: modalId, closeModal: closeModal, data: visibleFarmers, filters: filters, submitFilter: handleFilter, resetCallback: resetCallback, resetMap: resetMap, handleZoom: handleZoom }));
    };
    return (React.createElement(MapFiltersStyled, null,
        React.createElement("span", { className: "sort-filter" }, "Showing " + filteredFarmers.length + " Results"),
        React.createElement(FilterButton, { onClick: function () { return handleModal(); } },
            React.createElement(ReactSVG, { className: "filterIcon", src: imgsFolder + "/" + imgs.icons.iconFilter }),
            filterSize > 0 && React.createElement(Counter, null, filterSize),
            "FILTERS")));
};
export default MapFilters;
//# sourceMappingURL=MapFilters.js.map